import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function errorMsg(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Ocurrió un error";
}

export function nombreModelo(marca, modelo) {
  const ma = (marca || "").trim();
  const mo = (modelo || "").trim();
  if (!ma) return mo;
  if (mo.toUpperCase().startsWith(ma.toUpperCase())) return mo;
  return `${ma} ${mo}`.trim();
}

export function modeloIdDe(trabajo) {
  return trabajo?.modelo_id ?? trabajo?.vehiculo?.modelo_id;
}

export function colones(n) {
  return `₡ ${Number(n || 0).toLocaleString("es-CR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export const ESTADO_PEDIDO_LABEL = {
  solicitado: "Solicitado", pedido_fabrica: "Pedido a fábrica", en_transito: "En tránsito",
  recibido: "Recibido", entregado: "Entregado", cancelado: "Cancelado",
};

export function fmtFechaCorta(d) {
  if (!d) return "";
  const [y, m, dd] = d.slice(0, 10).split("-");
  return `${dd}/${m}/${y}`;
}

// Pedido especial ligado a una línea de repuesto de una solicitud (mismo repuesto_id, o mismo
// código si fue agregado a mano sin repuesto_id). Usado para el chip en Solicitud/Aprobación.
export function pedidoDeRepuesto(trabajo, s) {
  if (!s || s.tipo !== "repuesto") return null;
  return (trabajo?.pedidos_especiales || []).find((p) => (p.repuestos || []).some((r) =>
    (s.ref_id && r.repuesto_id === s.ref_id) || (!r.repuesto_id && r.codigo && r.codigo === s.codigo)));
}

const DIAS_SEMANA = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
const MESES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto",
  "septiembre", "octubre", "noviembre", "diciembre"];

function fmtHora12(hora) {
  if (!hora || !/^\d{1,2}:\d{2}/.test(hora)) return hora || "";
  const [h, m] = hora.split(":").map(Number);
  const ampm = h < 12 ? "a. m." : "p. m.";
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return `${h12}:${String(m).padStart(2, "0")} ${ampm}`;
}

// Estado de la agenda Nextep de un trabajo (cita previa al ingreso). Devuelve null si el
// trabajo es anterior a esta función (sin `con_cita`) y no debe mostrar nada.
export function textoAgendaNextep(trabajo) {
  if (!trabajo || trabajo.con_cita === null || trabajo.con_cita === undefined) return null;
  if (trabajo.con_cita === false) return { texto: "Sin cita previa", color: "slate" };
  const agenda = trabajo.agenda_nextep;
  if (!agenda) return null;
  if (agenda.estado === "encontrada" && agenda.cita) {
    const { fecha, hora, servicio, detalle } = agenda.cita;
    let fechaTxt = fecha || "";
    if (fecha) {
      const d = new Date(`${fecha}T00:00:00`);
      if (!isNaN(d.getTime())) fechaTxt = `${DIAS_SEMANA[d.getDay()]} ${d.getDate()} de ${MESES[d.getMonth()]}`;
    }
    const partes = [fechaTxt, fmtHora12(hora)].filter(Boolean).join(", ");
    const serv = servicio ? ` — ${servicio}` : "";
    return { texto: `Cita en agenda: ${partes}${serv}`, detalle: detalle || "", color: "emerald" };
  }
  if (agenda.estado === "sin_cita") return { texto: "No se encontró la cita en la agenda", color: "amber" };
  if (agenda.estado === "pendiente" || agenda.estado === "error") {
    if ((agenda.intentos || 0) >= 12) return { texto: "No se pudo consultar la agenda", color: "amber" };
    return { texto: "Consultando la agenda…", color: "slate" };
  }
  return null;
}

export const AGENDA_NEXTEP_COLOR_CLASS = { emerald: "text-emerald-700", amber: "text-amber-700", slate: "text-slate-500" };
